// extracted by mini-css-extract-plugin
module.exports = {"container":"StageQuiz_container__26C8C","question":"StageQuiz_question__1ZbU3","answer":"StageQuiz_answer__2Chlr"};